import { getCurrentConference } from '../base/conference/functions';
import { SET_DEEPAI_THEME } from './actionTypes';
import { getAiParticipant } from './functions';
/**
 * Sets (and persists) the active DeepAI theme.
 *
 * @param {string} theme - The theme id (one of DEEPAI_THEMES; empty = default).
 * @returns {{ type: string, theme: string }}
 */
export function setDeepaiTheme(theme) {
    return {
        type: SET_DEEPAI_THEME,
        theme
    };
}
/**
 * Sends a "stop speaking" command to the AI participant over the bridge data
 * channel (endpoint message). The command payload is configurable via
 * `config.deepaiStopCommand` so it can be matched to whatever the AI backend
 * listens for; it defaults to `{ type: 'barge-in' }`.
 *
 * @returns {Function}
 */
export function stopAiSpeaking() {
    return (_dispatch, getState) => {
        const state = getState();
        const conference = getCurrentConference(state);
        const ai = getAiParticipant(state);
        if (!conference || !ai) {
            return;
        }
        const command = state['features/base/config'].deepaiStopCommand ?? { type: 'barge-in' };
        try {
            conference.sendEndpointMessage(ai.id, command);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('[DeepAI] stopAiSpeaking: failed to send stop command', e);
        }
    };
}
